import { render, staticRenderFns } from "./OrganismInput.vue?vue&type=template&id=0c53c2a2&scoped=true"
import script from "./OrganismInput.vue?vue&type=script&lang=js"
export * from "./OrganismInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c53c2a2",
  null
  
)

export default component.exports